import { Order } from '../Table/types';
import { getSortValue } from '../Table/utils/sorting';
import { Row } from './types';

const comparatorByFullName = (a: Row['cells'], b: Row['cells']): number => {
  const userA = getSortValue(a.fullName);
  const userB = getSortValue(b.fullName);

  return userA.localeCompare(userB);
};

const comparatorByStatus = (
  a: Row['cells'],
  b: Row['cells'],
  orderCoef: number
) => {
  const userA = getSortValue(a.status);
  const userB = getSortValue(b.status);

  const equivalentCoef = userA.localeCompare(userB);

  if (!equivalentCoef) {
    return orderCoef * comparatorByFullName(a, b);
  }
  return equivalentCoef;
};

export const sortColumns = (
  order: Order,
  orderBy: string
): ((a: Row['cells'], b: Row['cells']) => number) => {
  const orderCoef = order === Order.Desc ? -1 : 1;

  if (orderBy === 'status') {
    return (a: Row['cells'], b: Row['cells']) =>
      orderCoef * comparatorByStatus(a, b, orderCoef);
  }
  return (a: Row['cells'], b: Row['cells']) =>
    orderCoef * comparatorByFullName(a, b);
};
